<div
	class="sdp-generic"
	*ngIf="!!tableData"
	[class.sdp-skeleton]="!isDataLoaded"
>
	<p-table
		#tt
		[columns]="columnSchema"
		[value]="tableData"
		[scrollable]="true"
		[scrollHeight]="scrollHeight"
		class="sdp-generic-table"
		[class.sdp-generic-table-disabled]="disabled"
		[paginator]="tableData.length > rows"
		[rows]="rows"
		(onFilter)="filterChange()"
		(onPage)="pageChange()"
		autoLayout="true"
	>
		<ng-template
			pTemplate="colgroup"
			let-columns
		>
			<colgroup>
				<col
					*ngFor="let col of columns"
					[style.width]="col.minWidth"
				>
			</colgroup>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th
					*ngFor="let col of columnSchema"
					[pSortableColumn]="col.bodySchema.boundField"
					[pSortableColumnDisabled]="!col.headerSchema.sortable"
					[class.ui-unsortable-column]="!col.headerSchema.sortable"
				>
					<span
						class="ui-column-title"
						[ngClass]="col.headerSchema.cssClass"
					>{{ col.headerSchema.headerText | translate }}</span>
					<p-sortIcon [field]="col.bodySchema.boundField"></p-sortIcon>
				</th>
			</tr>
			<tr *ngIf="isDataLoaded && tableData.length > 0">
				<th
					*ngFor="let col of columnSchema"
					[ngSwitch]="col.headerSchema.type"
					class="sdp-generic-filter-row"
				>
					<div
						*ngSwitchCase="'dateTime'"
						class="sdp-generic-dateTime-filter-show"
					>
						<p-calendar
							#calendar
							[(ngModel)]="datesGroup[col.bodySchema.boundField]"
							showTime="true"
							[maxDate]="now"
							[dateFormat]="col.headerSchema.dateFormat"
							[hourFormat]="col.headerSchema.hourFormat"
							(onClose)="doDateTimeChange(col.bodySchema.boundField, col.headerSchema.filterDirection)"
							class="p-cal-{{col.bodySchema.boundField}}"
						>
							<p-footer>
								<div class="sdp-calendar-footer">
									<button
										mat-raised-button
										color="primary"
										(click)="closeCalendar(col.bodySchema.boundField, col.headerSchema.filterDirection)"
									>{{ "sdp.label.close" | translate }}</button>
								</div>
							</p-footer>
						</p-calendar>
						<div
							class="sdp-generic-dateTime-filter-reset"
							*ngIf="datesGroup[col.bodySchema.boundField]"
							(click)="resetDateTimeFilter(col.bodySchema.boundField, col.headerSchema.filterDirection)"
							matTooltip="{{ 'generic.dateTime.dropdown.reset.tooltip' | translate }}"
						>x</div>
					</div>
					<div *ngSwitchCase="'substring'">
						<!-- TODO this will be replaced with class feature SDP-140 -->
						<input
							pInputText
							type="text"
							(input)="tt.filter($event.target.value, col.bodySchema.boundField, 'contains')"
							[value]="!!tt.filters[col.bodySchema.boundField] ? tt.filters[col.bodySchema.boundField].value : ''"
							[style.padding-left]="'5px'"
							[style.width]="'180px'"
							class="sdp-generic-corners"
						>
					</div>
					<div *ngSwitchCase="'multiSelect'">
						<p-multiSelect
							[options]="col.headerSchema.choices"
							defaultLabel="All"
							[showHeader]="true"
							(onChange)="tt.filter($event.value, col.bodySchema.boundField, 'in')"
							maxSelectedLabels="1"
							[(ngModel)]="deviceTypeFilterList"
						></p-multiSelect>
					</div>
					<div *ngSwitchCase="'none'">
						<!-- do not display any header or filter elements -->
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template
			pTemplate="body"
			let-row
			let-columns="columnSchema"
			let-i="rowIndex"
		>
			<tr
				class="sdp-generic-table-allow-text-interaction"
				[ngClass]="!!rowSchema ? getCSSContent(rowSchema.cssClass, row): ''"
				[matTooltip]="!!rowSchema ? getTextContent(rowSchema.tooltip, row): ''"
			>
				<td
					*ngFor="let col of columnSchema"
					[ngSwitch]="col.bodySchema.type"
					class="sdp-p-table-body-column"
				>
					<div *ngIf="isDataLoaded; else DataNotLoaded">
						<div
							*ngSwitchCase="'toggle'"
							[ngClass]="col.bodySchema.cssClass"
							[class.sdp-skeleton]="isDataLoaded"
							class="sdp-generic-table-body-column"
						>
							<mat-slide-toggle
								(change)="toggleChange(col, row, $event)"
								[(ngModel)]="row[col.bodySchema.boundField]"
							></mat-slide-toggle>
						</div>
						<div
							*ngSwitchCase="'dateTime'"
							[class.sdp-datetime-active]="!row[col.bodySchema.boundField]"
							[ngClass]="col.bodySchema.cssClass"
							class="sdp-generic-table-body-column"
						>
							{{ col.bodySchema.displayCallback(row[col.bodySchema.boundField]) }}
						</div>
						<div
							*ngSwitchCase="'string'"
							[ngClass]="getCSSContent(col.bodySchema.cssClass,row)"
							[class.sdp-skeleton]="isDataLoaded"
							class="sdp-generic-table-body-column truncate"
						>
							{{ !!col.bodySchema.displayCallback ? col.bodySchema.displayCallback(row) : row[col.bodySchema.boundField] }}
						</div>
						<div
							*ngSwitchCase="'deviceType'"
							[class.sdp-skeleton]="isDataLoaded"
							class="sdp-generic-table-body-column"
						>
							<sdp-generic-device-type-column
								[deviceType]="row[col.bodySchema.boundField]"
								[cssClass]="col.bodySchema.cssClass"
							></sdp-generic-device-type-column>
						</div>
						<div
							*ngSwitchCase="'tag'"
							[ngClass]="col.bodySchema.cssClass"
							[class.sdp-skeleton]="isDataLoaded"
							class="sdp-generic-table-body-column sdp-generic-table-body-column-tag"
						>
							<div *ngIf="row[col.bodySchema.boundField].length === 0; else hasTags">
								{{ "generic.table.tags.noTags" | translate }}
							</div>
							<ng-template #hasTags>
								<span
									class="sdp-administrative-role-tag"
									*ngFor="let tag of row[col.bodySchema.boundField]; let i = index;"
								>{{ tag }}</span>
							</ng-template>
						</div>
						<div
							*ngSwitchCase="'button'"
							[ngClass]="col.bodySchema.cssClass"
							[class.sdp-skeleton]="isDataLoaded"
							class="sdp-generic-table-body-column sdp-generic-table-body-column-button"
						>
							<ng-container *ngFor="let button of col.bodySchema.buttons">
								<button
									*ngIf="button.type === 'icon' && (button.showButton === undefined || button.showButton(row))"
									mat-icon-button
									(click)="button.onClick(row)"
									color="primary"
									class="sdp-icon-button"
									matTooltip="{{ getTextContent(button.tooltip, row) }}"
									[disabled]="!!button.disabled && button.disabled(row)"
								>
									<sdp-icon [icon]="button.icon"></sdp-icon>
								</button>
								<button
									*ngIf="button.type === 'text' && (button.showButton === undefined || button.showButton(row))"
									mat-raised-button
									(click)="button.onClick(row)"
									color="accent"
									[ngClass]="button.cssClass"
									matTooltip="{{ getTextContent(button.tooltip, row) }}"
									[disabled]="!!button.disabled && button.disabled(row)"
								>
									{{ getTextContent(button.text, row) }}
								</button>
							</ng-container>
						</div>
						<div *ngSwitchCase="'customComponent'">
							<div
								*ngIf="isDataLoaded"
								class="sdp-generic-table-body-column-image"
							>
								<sdp-generic-custom-component-column
									[componentConstructor]="col.bodySchema.customComponent"
									[initFunc]="col.bodySchema.callback"
									[data]="row"
								></sdp-generic-custom-component-column>
							</div>
						</div>
						<div *ngSwitchCase="'icon'">
							<div class="sdp-generic-table-body-column-icon">
								<ng-container *ngIf="col.bodySchema.showIcon === undefined || col.bodySchema.showIcon(row)">
									<sdp-icon
										[icon]="col.bodySchema.icon"
										[row]="row"
										matTooltip="{{ getTextContent(col.bodySchema.tooltip, row) }}"
									></sdp-icon>
								</ng-container>
							</div>
						</div>
					</div>
					<ng-template #DataNotLoaded>
						<div class="sdp-generic-table-body-column sdp-generic-table-body-column-no-data">&nbsp;</div>
					</ng-template>
				</td>
			</tr>
		</ng-template>
		<ng-template
			pTemplate="emptymessage"
			let-columns
		>
			<tr>
				<td [attr.colspan]="columns.length">
					<h4 class="sdp-generic-table-no-records">{{ "generic.no.records" | translate }}</h4>
				</td>
			</tr>
		</ng-template>
	</p-table>
	<div
		*ngIf="tableData.length > rows"
		class="sdp-generic-total-records"
		[class.sdp-skeleton]="isDataLoaded"
	>
		{{ totalRecords }}
	</div>
</div>